import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Transition } from 'react-transition-group'
import { fadeStyle, modelStyle, slideDownStyle, slideLeftStyle, slideRightStyle, slideUpStyle } from './styles';

export declare type AnimationType = "fade" | "slide-left" | "slide-right" | "slide-up" | "slide-down" | "modal";
declare type DialogTransitionProps = {
    children: React.ReactElement<any>,
    duration: { enter: number, exit: number },
    in?: boolean,
    animation: AnimationType,
    key2: string;
    onExited?: (node: HTMLElement) => void;
}
export class DialogTransition extends React.Component<DialogTransitionProps>
{
    constructor(props: DialogTransitionProps) {
        super(props);
    }
    getTransitionStyle(animation: AnimationType, enter: number, exit: number) {
        switch (animation) {
            case "fade": return fadeStyle(enter, exit);
            case "slide-left": return slideLeftStyle(enter, exit);
            case "slide-right": return slideRightStyle(enter, exit);
            case "slide-up": return slideUpStyle(enter, exit);
            case "slide-down": return slideDownStyle(enter, exit);
            case "modal": return modelStyle(enter, exit);
        }
    }
    renderChildren = (state: 'entering' | 'entered' | 'exiting' | 'exited') => {
        const { animation, children } = this.props;
        const transitionStyle = this.getTransitionStyle(animation, this.props.duration.enter, this.props.duration.exit);
        //@ts-ignore
        const animationStyle = transitionStyle[state];
        // console.log(this.props.key2, state, animation, animationStyle, this.props.duration.enter, this.props.duration.exit);
        if (state === 'exited') {
            return null;
        }
        const child = React.Children.only(children);
        const style = { ...child.props.style, ...transitionStyle.defaultStyle, ...animationStyle };
        const clone = React.cloneElement(child, { style });
        return ReactDOM.createPortal(clone, document.body);
    }
    onExited = (node: HTMLElement) => {
        if (this.props.onExited) this.props.onExited(node);
    }
    render() {
        const { duration, in: inProp } = this.props;
        return <Transition in={inProp} timeout={duration} onExited={this.onExited}>
            {this.renderChildren}
        </Transition>;
    }
}